<template>
  <div class="box9">
    <pageTitle title="职场进阶课程 带你斩获深层技能" titleColor="#3E4F48" />
    <div class="skillBox">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="
          cur = index;
          show = true;
        "
      >
        <div class="itemTitle">{{ item.nav }}</div>
        <div class="desc">
          课时:
          {{ item.day }}h&nbsp;&nbsp;技术点: {{ item.point }}项
        </div>
        <div class="btn">查看详情</div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div class="block" v-if="show">
        <div class="block-tops">
          <div class="title">{{ list[this.cur].nav }}</div>
          <div class="close" @click="show = false"></div>
        </div>
        <div class="tag">
          <img src="../../../assets/coursePage/web/box9/icon1.png" alt="" />
          学习目标
        </div>
        <div class="exp">{{ list[this.cur].aims }}</div>

        <div class="tag">
          <img src="../../../assets/coursePage/web/box9/icon2.png" alt="" />
          主讲内容
        </div>
        <div class="content">
          <div
            v-for="(item, index) in list[this.cur].content"
            :key="index"
            class="itemContent"
          >
            <p>{{ item.lear }}</p>
            <div class="tagBox">
              <div
                class="tag"
                v-for="(item1, index1) in item.tag"
                :key="index1"
              >
                {{ item1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
  mounted() {},

  data() {
    return {
      show: false,
      list: [
        {
          nav: "React.js 高级",
          day: "24",
          point: "36",
          aims: "能够结合 TypeScript+Hooks 与函数式编程思想完成项目开发。",
          content: [
            {
              lear: "1. TypeScript 基础",
              tag: [
                "静态类型",
                "基础类型和对象类型",
                "类型注解和类型推断",
                "函数相关类型",
                "数组和元组",
                "Interface 接口",
                "类",
                "继承",
                "构造器",
                "Setter 和 Getter",
                "抽象类",
              ],
            },
            {
              lear: "2. TypeScript 高阶语法",
              tag: [
                "联合类型和类型保护",
                "Enum",
                "函数泛型",
                "类中的泛型",
                "命名空间",
                "模块化",
                "描述文件",
              ],
            },
            {
              lear: "3. Hooks",
              tag: ["useState", "useEffect", "useContext", "自定义 Hooks"],
            },
            {
              lear: "4. 函数式编程",
              tag: [
                "纯函数",
                "柯里化",
                "函数组合",
                "Point Free",
                "声明式与命令式",
              ],
            },
            {
              lear: "5. Redux 中间件",
              tag: ["React-Redux", "redux-thunk", "redux-saga"],
            },
          ],
        },
        {
          nav: "多端跨平台",
          day: "105",
          point: "124",
          aims: "学完课程能够真正实现一套代码多端运行，减少开发成本，提高开发效率。",
          content: [
            {
              lear: "1. Flutter 小兔鲜儿项目",
              tag: [
                "开发环境搭建",
                "Dart 入门",
                "StatelessWidget",
                "StatefulWidget",
                "布局",
                "路由和导航",
                "手势",
                "事件",
                "资源文件",
                "生命周期",
                "拍照和图片",
                "动画",
                "网络请求",
                "列表组件",
                "屏幕适配",
                "混合开发",
                "性能优化",
                "Plugin",
                "打包发布",
              ],
            },
            {
              lear: "2. 小兔鲜儿原生小程序精讲",
              tag: [
                "脚手架",
                "项目配置",
                "编译配置",
                "条件编译",
                "适配",
                "跨平台支持",
                "sass",
                "组件通信",
                "分包加载",
                "消息推送",
                "多线程",
                "插件",
                "云开发",
              ],
            },
            {
              lear: "3. PWA",
              tag: [
                "PWA 简介与优点",
                "PWA 背后的技术与原理",
                "PWA 现状",
                "manifest",
                "Service Worker",
                "消息推送的实现",
                "PWA 浏览器兼容情况",
              ],
            },
          ],
        },
        {
          nav: "前端工程化",
          day: "48",
          point: "39",
          aims: "学后能够在项目开发中实现自动化、规范化、组件化、模块化。",
          content: [
            {
              lear: "1. webpack 核心",
              tag: [
                "基本配置",
                "loader",
                "plugin",
                "SourceMap",
                "HMR",
                "Shimming",
                "CodeSplitting",
                "TreeShaking",
                "Caching",
                "性能优化",
                "多页应用",
                "PreLoading",
                "PreFetching",
              ],
            },
            {
              lear: "2. 脚手架工具",
              tag: ["vue-cli", "create-react-app", "angular-cli", "CLI 原理"],
            },
            {
              lear: "3. git flow 全流程",
              tag: [
                "rebase",
                "commit",
                "reflog",
                "log",
                "submodule",
                "subtree",
                "fetch",
                "checkout",
                "merge",
                "reset",
                "checkout",
                "rm",
                "mv",
                "branch",
                "switch",
                "git flow",
              ],
            },
          ],
        },
        {
          nav: "前端服务化",
          day: "34.5",
          point: "135",
          aims: "学后能够掌握网站性能监控与埋点方案。",
          content: [
            { lear: "1. Koa / Egg", tag: ["Koa", "Egg", "中间件"] },
            { lear: "2. NoSQL", tag: ["Redis", "MongoDB"] },
            {
              lear: "3. 性能监控",
              tag: [
                "Sentry服务端搭建",
                "Sentry监控Vue项目",
                "Sentry精准错误定位",
                "Sentry服务端日志收集和监控",
              ],
            },
            {
              lear: "4. SSR",
              tag: ["SSR 运行原理", "SSR 环境搭建和配置", "Nuxt.js"],
            },
          ],
        },
      ],
      cur: 0,
    };
  },

  methods: {
    changeCur(index) {
      this.cur = index;
    },
    close() {
      this.showVideo = false;
    },
  },
};
</script>

<style lang="less" scoped>
.box9 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/web/box7/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .van-popup {
    max-height: calc(100vh - 80px);
  }
  .skillBox {
    display: flex;
    justify-content: space-between;
    padding: 0 32px;
    box-sizing: border-box;
    flex-wrap: wrap;
    margin-top: 48px;
    .item {
      width: 330px;
      height: 220px;
      background: #ffffff;
      box-shadow: 0px 4px 16px 0px rgba(12, 158, 123, 0.12);
      border-radius: 16px;
      text-align: center;
      position: relative;
      margin-bottom: 26px;
      .itemTitle {
        margin: 32px 0 8px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1d2129;
        line-height: 44px;
      }
      .desc {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
      }
      .btn {
        width: 100%;
        height: 68px;
        background: rgba(0, 181, 137, 0.04);
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #00b589;
        line-height: 68px;
        text-align: center;
        position: absolute;
        bottom: 0;
      }
    }
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 32px;
    background: #ffffff;

    background: #ffffff;
    border-radius: 24px 24px 0px 0px;
    box-sizing: border-box;
    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .tag {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1d2129;
      line-height: 44px;
      margin-bottom: 16px;

      img {
        margin-right: 12px;
        width: 32px;
        height: 32px;
      }
    }
    .exp {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin: 16px 0 40px 40px;
    }
    .content {
      padding-bottom: 68px;
      .itemContent {
        margin-left: 40px;
        p {
          margin: 12px 0 16px;
          font-size: 26px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 44px;
        }
        .tagBox {
          display: flex;
          flex-wrap: wrap;
        }
        .tag {
          margin-right: 16px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 40px;
          padding: 8px 20px;
          margin-right: 16px;
          background: rgba(220, 244, 233, 0.6);
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
